import { Outlet, Link, useNavigate } from 'react-router-dom';
import { AppBar, Box, Button, Container, Toolbar, Typography } from '@mui/material';
import { brand } from '../app/config';
import { useUserData } from '../hooks/useUserData';

export function PublicLayout() {
    const user = useUserData();
    const navigate = useNavigate();

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <AppBar
                position="sticky"
                color="inherit"
                elevation={0}
                sx={{ backdropFilter: 'blur(10px)', bgcolor: 'rgba(20,4,12,0.7)' }}
            >
                <Toolbar sx={{ gap: 2 }}>
                    <Link
                        to="/"
                        className="flex items-center gap-2"
                        style={{ textDecoration: 'none', color: 'inherit' }}
                    >
                        <img src={brand.logo} alt={`${brand.name} logo`} className="h-9 w-auto" />
                        <Typography variant="h6" sx={{ fontWeight: 900 }} color="primary">
                            {brand.name}
                        </Typography>
                    </Link>
                    <Box sx={{ flexGrow: 1 }} />
                    {user.logged ? (
                        <Button color="primary" variant="contained" onClick={() => navigate('/form')}>
                            Fai una richiesta
                        </Button>
                    ) : (
                        <Button color="primary" variant="contained" onClick={() => navigate('/login')}>
                            Accedi
                        </Button>
                    )}
                </Toolbar>
            </AppBar>

            <Container maxWidth="lg" sx={{ flexGrow: 1, py: 4 }}>
                <Outlet />
            </Container>

            <footer className="mt-auto border-t border-white/10 bg-black/40 px-4 py-6 text-center text-sm text-gray-400">
                <div className="flex flex-col items-center gap-1">
                    <span>{brand.tagline}</span>
                    <a href={brand.websiteUrl} target="_blank" rel="noreferrer" className="text-accent hover:underline">
                        {brand.websiteUrl.replace(/^https?:\/\//, '')}
                    </a>
                    <span>{[brand.vat, brand.credits].filter(Boolean).join(' — ')}</span>
                </div>
            </footer>
        </Box>
    );
}
